import { Component } from '@angular/core';

import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';

import { GlobalRecordService } from '../../services/global-record.service';

/**
 * Renders a checkbox grid cell for record selection.
 */
@Component({
	selector: 'grid-checkbox-cell-renderer',
	templateUrl: './grid-checkbox-cell-renderer.component.html',
	styleUrl: './grid-checkbox-cell-renderer.component.css'
})
export class GridCheckboxCellRendererComponent implements ICellRendererAngularComp {
	data: any;

	constructor(
		public globalRecordService: GlobalRecordService
	) { }

	agInit(params: ICellRendererParams): void {
		this.refresh(params);
	}

	refresh(params: ICellRendererParams): boolean {
		this.data = params.data;
		return true;
	}

	toggleRecordId(event: Event): void {
		let currentValue = this.globalRecordService.getRecord(this.data.id);
		this.globalRecordService.setRecord(this.data.id, !currentValue, true);
	}
}

